module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4210-455a83401537b268ef37fb7f80ccd8a6.jpg";